import angular from 'angular'
import AbaViewerService from './abaViewer.service'

export default angular.module('app.pages.admin.adminDashboard.directDebits.viewABA.abaViewer', [])
  .service('abaViewerService', AbaViewerService)
